<template>
  <div class="filter-popular">
    <div class="filter-popular__headline">
      <UiText
        :text="data.title"
        tag="h3"
        font="promo-heading-3"
        bold
        color="typography-title01"
        align-center
      />
    </div>

    <div class="filter-popular__list">
      <UiBtn
        v-for="item in data.data"
        :key="item.title"
        :text="item.title"
        :active="togglers[item.key]"
        color="default"
        size-small
        @click="changeSelectedItem(item.key)"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BaseInfoBtn from '@/components/Base/InfoBtn'

export default {
  name: 'FilterPopular',
  components: {
    BaseInfoBtn,
  },
  props: {
    data: { type: Object, required: true },
  },
  data() {
    return {
      togglers: {},
    }
  },
  computed: {
    ...mapGetters('lobby', [
      'get_filterOptions',
    ]),
  },
  mounted() {
    this.initFilter()
  },
  methods: {
    initFilter() {
      const { filterPopular } = this.get_filterOptions.selected
      const filters = this.data.data

      filters.forEach(el => {
        this.togglers[el.key] = (filterPopular && filterPopular[el.key]) || false
      })
      this.togglers = { ...this.togglers }
      this.$emit('input', this.togglers)
    },
    reset() {
      this.togglers = {}
    },
    changeSelectedItem(key) {
      this.togglers[key] = !this.togglers[key]
      this.togglers = { ...this.togglers }
      this.$emit('input', this.togglers)
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
